<div class="dialogbox-container ">

    <div class="header-wrapper pt-7 pr-7 pb-0 pl-7">
        <h2 class="heading black-text m-0 lighter-text">
            <ng-container [ngTemplateOutlet]="headContent"></ng-container>
        </h2>
        <img mat-dialog-close class="icon-m" src="assets/close-dialog.svg">
    </div>

    <div class="description pt-0 pr-0 pb-0 pl-8">
        <span class="subHeading span-m secondary-text">
      <ng-container [ngTemplateOutlet]="subHeadContent"></ng-container>
    </span>
    </div>


    <mat-dialog-content class="mx-5 my-0">
        <ng-container [ngTemplateOutlet]="htmlContent"></ng-container>
    </mat-dialog-content>

    <mat-dialog-actions>
        <ng-container [ngTemplateOutlet]="footContent"></ng-container>
    </mat-dialog-actions>

</div>